/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NexonAnalyticsUserRequest = {
    period: NexonAnalyticsUserRequest.period;
    from?: string;
    to?: string;
};

export namespace NexonAnalyticsUserRequest {

    export enum period {
        D7 = 'D7',
        M1 = 'M1',
        M6 = 'M6',
        YTD = 'YTD',
        Y1 = 'Y1',
        ALL = 'ALL',
    }


}

